// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphCard.tsx");
  import.meta.hot.lastModified = "1740183864615.858";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import clsx from "clsx";
import htmlParser from "~/components/helpers/htmlParser";
import Link from "~/components/Link";
import IconResolver from "~/components/IconResolver";
import Heading from "../Heading";
const variants = {
  primary: {
    wrapper: "items-center",
    title: "text-center",
    text: "text-neutral-600 text-center",
    image: "w-12 h-12 max-w-[128px]",
    cta: "justify-center",
    innerWrapper: ""
  },
  secondary: {
    wrapper: "items-start !flex-row",
    title: "",
    text: "text-white",
    image: "!max-w-[24px]",
    cta: "justify-center",
    innerWrapper: ""
  },
  tertiary: {
    wrapper: "items-center",
    title: "text-center",
    text: "text-neutral-600 text-center",
    image: "w-12 h-12 max-w-[128px]",
    cta: "justify-center",
    innerWrapper: ""
  },
  quaternary: {
    wrapper: "bg-neutral-100 p-6 border rounded-[10px] border-neutral-100",
    innerWrapper: "flex flex-col flex-grow",
    title: "flex-grow",
    text: "hidden",
    image: "w-full object-contain block max-w-full max-h-full",
    imageWrapper: "w-full max-h-[175px]",
    cta: "justify-start"
  }
};
export default function Card({
  Item = "li",
  imageOptional,
  title,
  text,
  cta,
  className,
  variant = "primary",
  type
}) {
  const {
    wrapper,
    title: titleVariant,
    text: textVariant,
    image,
    cta: ctaVariant,
    innerWrapper,
    imageWrapper
  } = variants[variant] || variants.primary;
  const components = htmlParser({
    html: text?.processed || ""
  });
  const typeMapping = {
    ParagraphCard: "card",
    ParagraphCardReference: "card_reference"
  };
  const calculatedType = typeMapping[type];
  return <Item className={clsx("flex flex-col gap-4 rounded-lg", wrapper, className)}>
      {imageOptional && <div className={imageWrapper}>
          <Image className={image} src={imageOptional.mediaImage.url} layout="constrained" alt={imageOptional.mediaImage.alt} width={imageOptional.mediaImage.width} height={imageOptional.mediaImage.height} />
        </div>}
      <hgroup className={innerWrapper}>
        <Heading tag="h3" className={titleVariant}>
          {title}
        </Heading>
        <div className={clsx("wysiwyg wysiwyg-a:no-underline wysiwyg-p:my-0 max-w-none", textVariant)}>
          {components}
        </div>
        {cta && cta.map(({
        title,
        url
      }) => <Link className={clsx("mt-2 text-center flex items-center w-full gap-1", ctaVariant)} key={title} to={url} target={calculatedType === "card" ? "_blank" : "_self"} rel={calculatedType === "card" ? "noopener noreferrer" : ""}>
              {title} <IconResolver token="chevron-right" className="w-6 h-6" />
            </Link>)}
      </hgroup>
    </Item>;
}
_c = Card;
var _c;
$RefreshReg$(_c, "Card");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;